






export default {
  props: {
    /**
     * The debug information to display.
     */
    debug: String,

    /**
     * The length and width of the tiles in pixels
     */
    size: Number,
  },
};
